import PropTypes from 'prop-types';

// import {
//   ScaleCard,
//   ScaleIconAlertError,
//   ScaleLink,
// } from '@telekom/scale-components-react';
import classes from './Error.module.scss';

const Error = (props) => {
	// const { translate } = useTranslate();
	return (
		// <ScaleCard
		<div
			className={classes.errorCard}
			label={translate(props.label)}
		>
			{/* <ScaleIconAlertError
				fill="#E20074"
				size="36"
				accessibility-title="error"
			/> */}
			<span className={classes.errorContent}>
				{translate(props.message)}
				{/* <ScaleLink
					omit-underline
					onClick={props.onRetry}
				>
					{translate(props.retryText)}
				</ScaleLink> */}
			</span>
		</div>
	);
};

Error.propTypes = {
	message: PropTypes.string,
	retryText: PropTypes.string,
	onRetry: PropTypes.func,
	label: PropTypes.string
};

Error.defaultProps = {
	message: "components.error.message",
	retryText: "components.error.retryText",
	onRetry: () => {},
	label: "components.error.label"
};

export default Error;
